import {get, post} from "@/config/api";


const state = {
};

const getters = {};

const mutations = {};

const actions = {
  GetGoodsById({}, params) {
    return new Promise((resolve, reject) => {
      get(`goods/get/${params.id}/`, params).then((data) => {
        resolve(data);
      }, (error) => {
        reject(error)
      })
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
